import request from '@/utils/request'

// 新增医疗器械产品注册资料预审 提交
export function addYlqx(data) {
  return request({
    url: '/web/zlts/ylqx',
    method: 'post',
    data: data
  })
}

//撤销
export function updateYlqxsb(data) {
  return request({
    url: '/web/zlts/ylqx/edit',

    method: 'post',
    data: data
  })
}

/**
 * 直接提交
 * @param data
 */
export function submitYlqxsb(data) {
  return request({
    url: '/web/zlts/ylqx/submitData',
    method: 'post',
    data: data
  })
}

// 查询医疗器械产品注册资料预审详细
export function getYlqxsb(recid) {
  return request({
    url: '/web/zlts/ylqx/' + recid,
    method: 'get'
  })
}

